import { Component } from '@angular/core';

@Component({
    selector: 'app-overlay-loader',
    templateUrl: './overlay-loader.component.html',
    standalone: false
})
export class OverlayLoaderComponent {

    constructor() { }

}
